import { useQuery } from '@tanstack/react-query';
import { fetchDealerConfigOptions } from '../services/dealerConfigOptions';
import type { DealerConfigOptionListParams } from '../types/dealerConfigOption.types';

/**
 * Query-key factory for the dealer config-options catalog. Deliberately
 * distinct from P4b's `dealerConfigSettingKeys` — the two never share a key.
 */
export const dealerConfigOptionKeys = {
  all: ['dealer-config-options'] as const,
  lists: () => [...dealerConfigOptionKeys.all, 'list'] as const,
  list: (params: DealerConfigOptionListParams) => [...dealerConfigOptionKeys.lists(), params] as const,
  detail: (id: string) => [...dealerConfigOptionKeys.all, 'detail', id] as const,
  combobox: () => [...dealerConfigOptionKeys.all, 'combobox'] as const,
};

export const useDealerConfigOptionsQuery = (params: DealerConfigOptionListParams = {}) =>
  useQuery({
    queryKey: dealerConfigOptionKeys.list(params),
    queryFn: () => fetchDealerConfigOptions(params),
    staleTime: 5 * 60 * 1000,
    gcTime: 10 * 60 * 1000,
  });
